import { Stack } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { DealerDetailsSkeleton } from './DealerDetailsSkeleton';
import { useFetchDealerDetailsPage } from 'modules/aftermarketPartner/hooks';
import { DealerInfoCard } from './DealerInfoCard';
import { ContactsCard } from './ContactsCard';
import { LocationsCard } from './LocationsCard';
import { ProposalsCard } from './ProposalsCard';
import { useSelector } from 'react-redux';
import { ModalsKeys } from 'global';
import { ReactNode } from 'react';
import { AddLocationDialog } from '../../dialogs/AddLocationDialog';
import { ModalsContainer } from 'components/shared/Modals';

export const DealerDetailsPage = ({ match }: any) => {
  const partnerLinkId = match.params.partnerLinkId;

  const routePath = `/dealers/${partnerLinkId}`;

  const account = useSelector((state: any) => state.account);

  const { isLoading, dealerAccount, proposals, partnerLinkMetrics, refetchDealerAccount } = useFetchDealerDetailsPage(
    account.id,
    partnerLinkId
  );

  const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
    [ModalsKeys.AftermarketPartnerAddLocationDialog]: <AddLocationDialog />,
  };

  return (
    <RenderWithFallback isLoading={isLoading} fallBack={<DealerDetailsSkeleton />}>
      <Stack gap={'2rem'}>
        <DealerInfoCard dealerAccount={dealerAccount} partnerLinkMetrics={partnerLinkMetrics} />
        <ContactsCard dealerAccount={dealerAccount} refetchDealerAccount={refetchDealerAccount} />
        <LocationsCard dealerAccount={dealerAccount} refetchDealerAccount={refetchDealerAccount} />
        <ProposalsCard proposals={proposals} routePath={routePath} />
      </Stack>

      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </RenderWithFallback>
  );
};
